import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDoorOpen, faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import {AuthService} from "../../services/AuthService";
import React from "react";
import {Trans, useTranslation} from "react-i18next";

export function LabelLoginRequired(props: {loggedIn: boolean}) {
  const {t} = useTranslation();

  const key = props.loggedIn ? "not_allowed_403" : "not_allowed_401";
  const color = props.loggedIn ? "#C00C0F" : "#7F7F7F";
  const icon = props.loggedIn ? faExclamationTriangle : faDoorOpen;

  return (
    <div className="container text-center my-auto mt-5">
      <FontAwesomeIcon icon={icon} color={color} size="4x" className="mb-4"/>
      <h4>{t(key + ".title")}</h4>
      <h6>{t(key + ".subtitle")}</h6>
    </div>
  );
}
